import { getController /*postController*/ } from '@/controllers/request';
import { MODULE, EVENTBUS_EVENTS, ACTION } from '@/utils/constants';
import { eventBus } from '@/bus';
import { errorMsg } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    vacancyListData: {},
    currentVacancyCandidate: null,
    fields: {},
    roleStatus: {},
    stages: [],
    selectedStage: null,
    activityDate: '',
    inviteAndRefuseText: {},
    metadata: {},
    dashbordApplying: false,
    changeableList: {
      changeable: false,
      list: []
    },
    changeableLink: '',
    loading: true,
    tableTitleParams: null,
    query: false
  },
  mixins: [errorMsg],
  mutations: {
    setChangeableListVisible(state) {
      state.changeableList.changeable = !state.changeableList.changeable;
    },
    setChangeableList(state, items) {
      state.changeableList.list = items;
    },
    setVacancyListData(state, value) {
      state.vacancyListData = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    },
    setRoleStatus(state, status) {
      state.roleStatus = status;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    // setProgressbar(state, val) {
    //   state['fields']['progresbar']['value'] = val;
    // },
    setFields(state, data) {
      state.fields = { ...data };
    },
    // setFieldParam(state, { variable, param, value }) {
    //   if (state[variable]) {
    //     state[variable][param] = value;
    //   }
    // },
    setInviteRefuseText(state, data) {
      state.inviteAndRefuseText = data;
    }
  },
  actions: {
    async getMetadata({ commit }, id) {
      commit('setLoading', true);
      try {
        const response = await getController({
          params: {
            module: MODULE.VACANCY_MODULE,
            action: 'get_VacancyView',
            record: id
          }
        });
        commit('setMetadata', response.data);
        commit('setFields', response.data?.bean);
        if (response.data?.bean?.id.value) {
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async loadVacanсies(
      { commit, rootState },
      { actionName, candidate_id, noFilters }
    ) {
      commit('setLoading', true);
      commit(
        'selectionPopup/setBaseParams',
        {
          module: MODULE.VACANCY_MODULE,
          action: actionName || ACTION.LIST_VIEW,
          candidate_id: candidate_id || '',
          jsqon_return: 1,
          to_pdf: true
        },
        { root: true }
      );

      let filters = {};
      let dataSortParams = '';
      let saved_search_select = '';
      if (!noFilters) {
        let currentFilters = {
          ...rootState.filters.filterConfig.custom_filters,
          ...rootState.filters.filterConfig.filters
        };

        dataSortParams = rootState.filters.filterConfig.sortable;
        saved_search_select =
          rootState.filters.filterConfig?.savedSearchData?.selected;

        for (let key in currentFilters) {
          if (
            currentFilters[key].value != null &&
            currentFilters[key].value != false
          ) {
            filters[key] = currentFilters[key].value;
          }
        }
      }

      let params = {
        module: MODULE.VACANCY_MODULE,
        displayMode: 'spa',
        action: actionName || ACTION.LIST_VIEW,
        candidate_id: candidate_id || '',
        HRPAC_VACANCY2_HRPAC_VACANCY_offset: 0
      };

      if (!noFilters) {
        params = { ...params, saved_search_select, ...filters };
      }

      if (rootState.filters.query) {
        params.query = true;
        commit(
          'filters/setParam',
          {
            name: 'query',
            val: false
          },
          { root: true }
        );
      }

      if (dataSortParams?.orderBy && !noFilters) {
        params['orderBy'] = dataSortParams.orderBy;
      }
      if (dataSortParams?.sortOrder && !noFilters) {
        params['sortOrder'] = dataSortParams.sortOrder;
      }

      try {
        const request = await getController({
          params
        });

        commit(
          'common/setTableData',
          {
            module: MODULE.VACANCY_MODULE,
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        // commit('selectionPopup/setPopupData', {
        //   data: Object.values(request.data.data.data),
        //   replace: true
        // }, { root: true });

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !request.data?.custom_search?.sortable?.default || false
          },
          { root: true }
        );

        commit('setVacancyListData', request.data);

        if (request.data.data.data.data?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: request.data.data.data.data.title_params
          });
        }

        if (request.data.data?.pageData?.queries?.baseURL?.name_advanced) {
          commit('filters/setFiltersActive', true, {
            root: true
          });
        }

        eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);
      } catch (error) {
        console.error(error);
        commit('setVacancyListData', {
          error:
            'У Вас нет доступа к данной странице. Свяжитесь с вашим системным администратором для получения соответствующих прав.'
        });
      } finally {
        commit('setLoading', false);
      }
    },
    async getACLStatus({ commit }, { id }) {
      try {
        const response = await getController({
          params: {
            module: MODULE.VACANCY_MODULE,
            action: 'get_VacancyView',
            record: id
          }
        });
        commit('setParam', { name: 'vacancyListData', val: response.data });
        // if (response.data?.bean?.id.value) {
        //   return true;
        // } else {
        //   return false;
        // }
      } catch (e) {
        console.error(e);
      }
    },
    // async getACLStatus({ commit }, { id }) {
    //   try {
    //     const { data } = await getController({
    //       params: {
    //         module: 'HRPAC_VACANCY',
    //         action: ACTION.GET_FIELDS_MODULE_CHECK_ACL,
    //         id: id,
    //         fields: ['status_id'],
    //         jsqon_return: 1,
    //         to_pdf: true
    //       }
    //     });
    //     commit('setRoleStatus', data[0]);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    // async getFields({ state }, { fields }) {
    //   // экшн получения нужных полей по кандидатам
    //   const formData = new FormData();
    //   formData.append('module', MODULE.VACANCY_MODULE);
    //   formData.append('action', ACTION.GET_MODULE_FIELDS);
    //   formData.append('id', state.fields.id.value);
    //   formData.append('to_pdf', true);
    //   if (fields && Array.isArray(fields)) {
    //     fields.forEach(name => formData.append('fields[]', name));
    //   }
    //   const request = await postController({ options: formData });
    //   return await request.data;
    // },
    async getUserInviteAndRefuseText({ commit }, userId) {
      try {
        const data = await getController({
          params: {
            module: 'Users',
            action: ACTION.GET_MODULE_FIELDS,
            id: userId,
            fields: ['response_invite_text', 'response_refuse_text'],
            jsqon_return: 1,
            to_pdf: true
          }
        });
        commit('setInviteRefuseText', {
          invite: data.data[0].value,
          refuse: data.data[1].value
        });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
